import FormItem from "@components/FormItem/FormItem";
import FormSection from "@components/FormSection/FormSection";
import type { VesselNominationOutletContext } from "@features/vessel-nomination/add/constants";
import { FORM_FIELDS } from "@features/vessel-nomination/add/constants";
import type { VesselNominationFormData } from "@features/vessel-nomination/add/schema/vesselNominationFormSchema";
import { FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import { LANG_BASE } from "../PreArrivalQuestionnaire";

const LastSireInspection = () => {
  const { t } = useTranslation();
  const { formData, updateFormData } = useOutletContext<VesselNominationOutletContext>();

  return (
    <FormProvider {...formData}>
      <FormSection
        title={t(`${LANG_BASE}.sections.last-sire-inspection`)}
        className="grid-cols-1 lg:grid-cols-2"
      >
        <FormItem<VesselNominationFormData, typeof FORM_FIELDS.LAST_SIRE_INSPECTION>
          testId="nomination-last-sire-inspection-input"
          name={FORM_FIELDS.LAST_SIRE_INSPECTION}
          type="date-picker"
          label={t(`${LANG_BASE}.fields.date`)}
          onFieldChange={updateFormData}
          dateConstraint="not-future"
          timePicker={false}
        />
        <FormItem<VesselNominationFormData, typeof FORM_FIELDS.ISSUING_AUTHORITY>
          testId="nomination-issuing-authority-input"
          name={FORM_FIELDS.ISSUING_AUTHORITY}
          type="text"
          label={t(`${LANG_BASE}.fields.issuing-authority`)}
          onFieldChange={updateFormData}
          maxChars={50}
        />
      </FormSection>
    </FormProvider>
  );
};

export default LastSireInspection;
